import request from '@/util/request';

/**
 * 登录
 * @param {phone,uuid,password} data
 */
export function departmentEmployeeList(params) {
    return request({
        url: `/api/v1/account/department/employee/list`,
        method: 'POST',
        params,
    })
}

export function departmentEmployeeUnion(params) {
    return request({
        url: `/api/v1/account/department/employee/union`,
        method: 'GET',
        params,
    })
}




